const token = localStorage.getItem('loggedin_access_token');
Pusher.logToConsole = process.env.MIX_APP_ENV !== 'production';
const switchToken = localStorage.getItem('switch_token');
export default new Pusher(process.env.MIX_PUSHER_APP_KEY, {
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    authEndpoint: '/broadcasting/auth',
    encrypted: true,
    auth: {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${token}`,
            "Switch-Token": switchToken
        },
    }
});

import Pusher from 'pusher-js';